import React, { useState } from 'react';
import { auth, googleProvider, db } from "../config/firebase";
import { deleteUser, signInWithPopup, reauthenticateWithCredential, GoogleAuthProvider } from "firebase/auth";
import { getDocs, query, where, updateDoc, doc, collection } from 'firebase/firestore';
import Button from '@mui/material/Button';
import BootstrapButton from 'react-bootstrap/Button';
import Backdrop from '@mui/material/Backdrop';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


function SettingsMenu(props) {

  const user = auth.currentUser;

  const { openSettings, setOpenSettings } = props;

  const [open, setOpen] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  // Handler for closing the backdrop
  const handleClose = () => {
    setOpenConfirmation(false);
    setOpenSettings(false);
  };

  // Handlers for switching to confirmation
  const handleOpenConfirmation = () => {
      setOpenConfirmation(true);
    };
  
    const handleCloseConfirmation = () => {
      setOpenConfirmation(false);
    };

  const bbcodeCollectionRef = collection(db, "bbcode");

  const updateDeletedEntries = async () => {
      try {
          const q = query(bbcodeCollectionRef, where("user", "==", auth.currentUser.email));
          const data = await getDocs(q);
          const filteredData = data.docs.map((doc) => {
              const docData = doc.data();
              return {
                  ...docData,
                  user: `${docData.user}_deletedUser`,
                  id: doc.id,
              };
          });

          // Update the Firebase database with the modified data
          for (const entry of filteredData) {
              const entryDocRef = doc(bbcodeCollectionRef, entry.id);
              await updateDoc(entryDocRef, { user: entry.user });
          }

      } catch (err) {
          console.error(err);
      }
  };

  
  // The actual delete action
  const handleDeleteAccount = () => {
    handleClose();
    updateDeletedEntries();
    deleteUser(user).then(() => {
      console.log("Account deleted successfully.");
    }).catch((error) => {
      console.error(error);
      signInWithPopup(auth, googleProvider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        reauthenticateWithCredential(user, credential).then(() => {
          deleteUser(user).then(() => {
            console.log("Account deleted successfully.");
          }).catch((error) => {
            console.error(error);
            alert("Acount could not be deleted: An error ocurred.");
          });
        });
      }).catch((error) => {
        console.error(error);
        alert("Account could not be deleted: You must reauthenticate before deleting your account.");
      })
    }).catch((error) => {
      console.error(error);
      alert("Account could not be deleted: You must reauthenticate before deleting your account.");
    });
  };

  React.useEffect(() => {
    setOpen(openSettings);
  }, [openSettings]);

  return (
    <>
      <Backdrop
        open={open}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}
      >
          <Box sx={{ bgcolor: 'background.paper', borderRadius: 2, p: 2, zIndex: 2001 }}>
              {!openConfirmation && (
                <div style={{ minHeight: 300, minWidth: 500}}>
                  <div style={{float: "right"}}>
                    <IconButton variant="text" onClick={handleClose} style={{marginBottom: 15, color: "grey"}}><CloseIcon sx={{ width: 28, height: 28 }} /></IconButton>
                  </div>
                  <div style={{ display: "grid", justifyContent: "left", alignItems: "left" }}>
                    <h3 style={{ color: "black", textAlign: "left" }}>Account Settings</h3>
                    <Divider sx={{bgcolor: "#5d4ef3"}} />
                    <BootstrapButton style={{marginTop: 15}} variant="danger" onClick={handleOpenConfirmation}>Delete Account</BootstrapButton>
                  </div>
                </div>
              )}
              {openConfirmation && (
                  <Alert severity="error">
                      <AlertTitle>Are you sure you want to delete your account?</AlertTitle>
                      This will permanently delete all data associated with your account.
                      <Box mt={2}>
                      <Button variant="outlined" color="error" onClick={handleCloseConfirmation}>
                          Cancel
                      </Button>
                      <Button
                          variant="contained"
                          color="error"
                          onClick={handleDeleteAccount}
                          sx={{ marginLeft: 1 }}
                      >
                          Confirm
                      </Button>
                      </Box>
                  </Alert>
              )}
          </Box>
      </Backdrop>
    </>
  );
}
  
  export default SettingsMenu;